import React, {Component, PropTypes} from "react";

export default class ShowMore extends Component {
  static defaultProps = {
    open: false
  };

  static propTypes = {
    open: PropTypes.bool
  };

  constructor(props) {
    super(props);
    const { open } = props;
    this.state = {
      open: open
    };
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen = () => {
    this.setState({
      "open": !this.state.open
    });
  }

  render() {
    const open = this.state.open;

    return (
      <div className="show-more">
        <button type="button" className="btn btn-default btn-xs" onClick={this.toggleOpen}>{ open ? 'Hide description' : 'Show description'}</button>
        { this.state.open && this.props.children }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ShowMore.js